import React from 'react';
import {Navbar, Nav} from 'react-bootstrap';
import {Link} from "react-router-dom";
import './Home.css';


const CustomNavbar = () => {
    return ( 
    <div>
        <Navbar collapseOnSelect  expand="lg" variant="dark" defaultActiveKey="/home" className="color-nav">
           <Navbar.Brand href="#home">
              <img
              src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596770/nonedb/BUK_Company_Profile_Official_2020-20_jjbmqq.jpg"
              width="130"
              height="90"
              className="d-inline-block align-top"
              alt="BUK logo"
              />
           </Navbar.Brand>
           <Navbar.Toggle />
  <Navbar.Collapse className="justify-content-end">
           <span className="justify-content-right">
                   <Nav className="justify-content-end">
                        <Nav.Link eventKey="1"><Link to="/">Home</Link></Nav.Link>
                        <Nav.Link eventKey="2"><Link to="/contact">Contact</Link></Nav.Link>
                        <Nav.Link eventKey="3"><Link to="/mining">Mining</Link></Nav.Link>
                        <Nav.Link eventKey="4"><Link to="/special">Special Vehicles Supply</Link></Nav.Link>
                        <Nav.Link eventKey="5"><Link to="/branches">Branches</Link></Nav.Link>
                        <Nav.Link eventKey="6"><Link to="/industriel">Industriel Vehicles Supply</Link></Nav.Link>
                        <Nav.Link eventKey="7"><Link to="/railway">Railway Parts</Link></Nav.Link>
                        <Nav.Link eventKey="8"><Link to="/awards">Awards</Link></Nav.Link>
                        <Nav.Link eventKey="9"><Link to="/about">About</Link></Nav.Link>
                        <Nav.Link eventKey="10">Email: sales@buktruckparts.co.zm</Nav.Link>
                  </Nav>
          </span>
          </Navbar.Collapse> 
       </Navbar>
    </div>
     );
}
 
export default CustomNavbar;